import React from 'react';

/**
 * Metric tile for dashboard headers.
 *
 * Every tile is structurally identical — the accent only shifts the icon chip,
 * never the number, so a row of tiles reads as one set rather than a rainbow.
 * Values use tabular figures so the digits don't shift as counts update.
 */

const ACCENTS = {
  neutral: 'bg-muted text-muted-fg',
  info: 'bg-info-soft text-info',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  danger: 'bg-danger-soft text-danger',
};

const StatTile = ({ label, value, meta, icon: Icon, accent = 'neutral', onClick, active = false }) => {
  const Wrapper = onClick ? 'button' : 'div';

  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={[
        'flex w-full items-center justify-between gap-3 rounded-lg border bg-surface p-3 text-left shadow-sm sm:p-4',
        'transition-all duration-base ease-out',
        active ? 'border-accent ring-2 ring-accent/30' : 'border-border',
        onClick ? 'cursor-pointer hover:-translate-y-0.5 hover:shadow-md' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="min-w-0">
        <p className="truncate text-xs font-medium uppercase tracking-wide text-muted-fg">{label}</p>
        <p className="tabular mt-1 text-2xl font-semibold text-foreground">{value}</p>
        {meta && <p className="mt-1 truncate text-xs text-muted-fg">{meta}</p>}
      </div>
      {Icon && (
        <div
          className={`hidden h-10 w-10 shrink-0 items-center justify-center rounded-lg sm:flex ${
            ACCENTS[accent] || ACCENTS.neutral
          }`}
        >
          <Icon style={{ fontSize: 20 }} aria-hidden="true" />
        </div>
      )}
    </Wrapper>
  );
};

export default StatTile;
